import React from 'react'
import { DocumentChecklistsTable } from './components/DocumentChecklistsTable'
import { DocumentChecklistsTableProvider } from './DocumentChecklistsTableContext'

const DocumentChecklists: React.FC = () => (
  <DocumentChecklistsTableProvider>
    <DocumentChecklistsTable />
  </DocumentChecklistsTableProvider>
)

export default DocumentChecklists
